"use client";

import React from "react";

const documentDirections = ["ltr", "rtl"] as const;
export type Direction = (typeof documentDirections)[number];

export function isDirection(dir: string): dir is Direction {
  return documentDirections.includes(dir as Direction);
}

export const DirectionContext = React.createContext<Direction | null>(null);
